(function () {
    if (window.__designFeeSyncInit) return;
    window.__designFeeSyncInit = true;

    var CUSTOM_TEE_PRODUCT_ID = 10785257783577;
    var FEE_VARIANT_ID = 53096034369817;
    var SYNC_SOURCE = 'design-fee-sync';
    var busy = false;
    var pending = false;

    function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
    return r.json();
    });
    }

    function findCustomTeeQty(cart) {
    var qty = 0;
    cart.items.forEach(function (item) {
    if (item.product_id === CUSTOM_TEE_PRODUCT_ID) qty += item.quantity;
    });
    return qty;
    }

    function findFeeLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].variant_id === FEE_VARIANT_ID) {
    return { item: cart.items[i], line: i + 1 };
    }
    }
    return null;
    }

    function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
    }

    function sectionsToRender() {
    var list = [
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
    ];
    var mainItems = document.getElementById('main-cart-items');
    if (mainItems && mainItems.dataset.id) {
    list.push({ id: 'main-cart-items', section: mainItems.dataset.id, selector: '.js-contents' });
    }
    var mainFooter = document.getElementById('main-cart-footer');
    if (mainFooter && mainFooter.dataset.id) {
    list.push({ id: 'main-cart-footer', section: mainFooter.dataset.id, selector: '.js-contents' });
    }
    return list;
    }

    function applySections(sections) {
    if (!sections) return;
    sectionsToRender().forEach(function (s) {
    if (!sections[s.section]) return;
    var container = document.getElementById(s.id);
    if (!container) return;
    var elementToReplace = container.querySelector(s.selector) || container;
    var innerHTML = getSectionInnerHTML(sections[s.section], s.selector);
    if (innerHTML !== null) {
    elementToReplace.innerHTML = innerHTML;
    }
    });
    }

    function applyCartDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
    selectors.forEach(function (selector) {
    var targetElement = document.querySelector(selector);
    var sourceElement = doc.querySelector(selector);
    if (targetElement && sourceElement) {
    targetElement.replaceWith(sourceElement);
    }
    });
    }

    function notifyCartUpdate(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: SYNC_SOURCE, cartData: cart });
    }
    }

    function mutationBody(extra) {
    var body = {
    sections: sectionsToRender().map(function (s) { return s.section; }).concat(['cart-drawer']),
    sections_url: window.location.pathname,
    };
    for (var key in extra) {
    if (Object.prototype.hasOwnProperty.call(extra, key)) {
    body[key] = extra[key];
    }
    }
    return JSON.stringify(body);
    }

    function addFee() {
    return fetch(routes.cart_add_url, Object.assign(fetchConfig(), {
    body: mutationBody({ id: FEE_VARIANT_ID, quantity: 1 }),
    })).then(function (r) { return r.json(); });
    }

    function changeFeeLine(line, quantity) {
    return fetch(routes.cart_change_url, Object.assign(fetchConfig(), {
    body: mutationBody({ line: line, quantity: quantity }),
    })).then(function (r) { return r.json(); });
    }

    function reconcile() {
    if (busy) {
    pending = true;
    return;
    }
    busy = true;
    getCart()
    .then(function (cart) {
    var qty = findCustomTeeQty(cart);
    var feeLine = findFeeLine(cart);

    if (qty > 0 && !feeLine) {
    return addFee();
    }
    if (qty > 0 && feeLine && feeLine.item.quantity !== 1) {
    return changeFeeLine(feeLine.line, 1);
    }
    if (qty === 0 && feeLine) {
    return changeFeeLine(feeLine.line, 0);
    }
    return null;
    })
    .then(function (result) {
    busy = false;
    if (result) {
    applySections(result.sections);
    applyCartDrawer(result.sections);
    notifyCartUpdate(result);
    }
    if (pending) {
    pending = false;
    reconcile();
    }
    })
    .catch(function (e) {
    busy = false;
    console.error('Design fee sync error:', e);
    });
    }

    document.addEventListener('DOMContentLoaded', reconcile);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === SYNC_SOURCE) return;
    reconcile();
    });
    }
    })();